export default __webpack_public_path__ + "static/media/display_card.24e44a10.svg";